const ymd = (d) => d.toLocaleDateString("en-CA");

// "YYYY-MM-DD" due date → { text, overdue } in plain words, using the viewer's local day.
export function dueLabel(due) {
  if (!due) return null;
  const now = new Date();
  const today = ymd(now);
  const tomorrow = ymd(new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1));
  if (due < today) return { text: "overdue", overdue: true };
  if (due === today) return { text: "due today", soon: true };
  if (due === tomorrow) return { text: "due tomorrow", soon: true };
  const [y, m, d] = due.split("-").map(Number);
  return { text: `due ${new Date(y, m - 1, d).toLocaleDateString(undefined, { month: "short", day: "numeric" })}` };
}

export const DueTag = ({ due, testId }) => {
  const l = dueLabel(due);
  if (!l) return null;
  const tone = l.overdue ? "bg-red-600 text-white" : l.soon ? "bg-amber-100 text-amber-800" : "bg-slate-100 text-slate-600";
  return <span className={`shrink-0 rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${tone}`} data-testid={testId}>{l.text}</span>;
};

// Edgar's spoken summary of an assistant's work.
export function workSpeech(data, first) {
  const all = [...(data.photo || []), ...(data.media || [])].filter((b) => b.left).sort((a, b) => (a.due_date || "9999").localeCompare(b.due_date || "9999"));
  const y = data.yesterday || {};
  const recap = y.listed || y.drafted ? ` Yesterday you listed ${y.listed} and drafted ${y.drafted}.` : "";
  if (!all.length) return `${first ? `${first}, you're` : "You're"} all caught up. Nothing is waiting for you right now.${recap}`;
  const parts = all.slice(0, 4).map((b) => `${b.name}, ${b.left} left${dueLabel(b.due_date) ? `, ${dueLabel(b.due_date).text}` : ""}`);
  const more = all.length > 4 ? ` Plus ${all.length - 4} more.` : "";
  return `You have ${all.length} batch${all.length > 1 ? "es" : ""} to work on. ${parts.join(". ")}.${more}${recap}`;
}
